import React from "react";
import UserInfoTile from "./UserInfoTile";

const TeamUsers = ({ team_name, users, handleSelectTeam, handleSelectUser, selectedUsers }) => {
  return (
    <div className="mt-4">
      <div>
        <div className="flex items-center justify-between">
          <div className="text-[14px] font-semibold font-inter text-[#1E293B]">
            {team_name} Team
          </div>
          <div
            onClick={(e) => {
              e.preventDefault();
              handleSelectTeam(users);
            }}
            className="text-[10px] font-semibold font-inter text-[#2F80ED] cursor-pointer"
          >
            Select Team
          </div>
        </div>
        {users?.map((item) => (
          <UserInfoTile key={item.id} user={item} handleSelectUser={handleSelectUser} is_selected={true} selectedUsers={selectedUsers} />
        ))}
      </div>
    </div>
  );
};

export default TeamUsers;
